import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";
import { usePrefs } from "./PrefsContext";

const ContentContext = createContext(null);

export function ContentProvider({ children }) {
  const { lang } = usePrefs();
  const [content, setContent] = useState(null);

  useEffect(() => {
    setContent(null);
    api.get(`/content?lang=${lang}`).then(({ data }) => setContent(data)).catch(() => {});
  }, [lang]);

  return <ContentContext.Provider value={content}>{children}</ContentContext.Provider>;
}

export const useContent = () => useContext(ContentContext);
